import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "grid grid-cols-2 gap-8 place-items-center px-4 py-2 border-b border-gray-lp-200 bg-gray-lp-100 rounded",
  style: {"height":"fit-content"}
}
const _hoisted_2 = { class: "mt-3 overflow-auto h-full pb-5" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 1,
  class: "flex flex-col gap-8"
}
const _hoisted_6 = { class: "flex flex-col gap-2" }
const _hoisted_7 = { class: "flex flex-col gap-2" }
const _hoisted_8 = { class: "flex flex-col gap-2" }
const _hoisted_9 = { class: "flex flex-col gap-2" }
const _hoisted_10 = { class: "flex flex-col gap-2" }
const _hoisted_11 = { class: "flex flex-col gap-2" }
const _hoisted_12 = { class: "flex flex-col gap-2" }
const _hoisted_13 = { class: "flex flex-col gap-2" }
const _hoisted_14 = { class: "flex flex-col gap-2" }
const _hoisted_15 = { class: "flex flex-col gap-2" }
const _hoisted_16 = { class: "flex flex-col gap-2" }
const _hoisted_17 = {
  key: 0,
  class: "bg-white absolute bottom-4 w-full"
}
const _hoisted_18 = {
  key: 1,
  class: "bg-white absolute bottom-4 w-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Note = _resolveComponent("Note")!
  const _component_IssueSection = _resolveComponent("IssueSection")!
  const _component_SummarySTT = _resolveComponent("SummarySTT")!
  const _component_DelDexCodrej = _resolveComponent("DelDexCodrej")!
  const _component_PartnerSection = _resolveComponent("PartnerSection")!
  const _component_DetailItems = _resolveComponent("DetailItems")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_ModalFinishIssue = _resolveComponent("ModalFinishIssue")!
  const _component_ModalSuccessFinish = _resolveComponent("ModalSuccessFinish")!
  const _component_ModalReopenReason = _resolveComponent("ModalReopenReason")!
  const _component_Snackbar = _resolveComponent("Snackbar")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", {
      class: ["relative grid grid-rows-[auto_1fr] h-full", { 'h-full': !!_ctx.errorState }]
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", {
          class: ["py-3 px-2 w-full text-sm focus:outline-none transition-colors duration-200 cursor-pointer text-center", {
          'text-black-lp-200 bg-white font-semibold shadow rounded':
            _ctx.activeTab === 'summary',
          'text-gray-lp-300 font-semibold': _ctx.activeTab !== 'summary'
        }],
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeTab = 'summary'))
        }, _toDisplayString(_ctx.$t("pusatResolusi.summaryTab")), 3),
        _createVNode("div", {
          class: ["py-3 px-2 w-full whitespace-nowrap text-sm focus:outline-none transition-colors duration-200 cursor-pointer text-center", {
          'text-black-lp-200 bg-white font-medium shadow rounded':
            _ctx.activeTab === 'detail',
          'text-gray-lp-300': _ctx.activeTab !== 'detail'
        }],
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeTab = 'detail'))
        }, _toDisplayString(_ctx.$t("pusatResolusi.detailInfoTab")), 3)
      ]),
      _createVNode("div", _hoisted_2, [
        (!_ctx.errorState && !_ctx.isLoading)
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              (_ctx.activeTab === 'summary')
                ? (_openBlock(), _createBlock("div", _hoisted_3, [
                    _createVNode("div", {
                      class: `space-y-4 ${_ctx.isShowSolveTicketButton ? 'mb-16' : 'mb-10'}`
                    }, [
                      _withDirectives(_createVNode(_component_Note, {
                        modelValue: _ctx.data.ticket.note,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.data.ticket.note = $event)),
                        onSubmit: _ctx.onSubmitNote
                      }, null, 8, ["modelValue", "onSubmit"]), [
                        [_vShow, _ctx.isShowNote]
                      ]),
                      _createVNode(_component_IssueSection, {
                        issueName: _ctx.data.ticket.category.label,
                        description: _ctx.data.ticket.desc,
                        attachment: _ctx.data.ticket.attachments
                      }, null, 8, ["issueName", "description", "attachment"]),
                      _createVNode(_component_SummarySTT, {
                        isSummary: "",
                        detailData: _ctx.summaryDetailData
                      }, null, 8, ["detailData"]),
                      (_ctx.isDelDexCodrej)
                        ? (_openBlock(), _createBlock(_component_DelDexCodrej, {
                            key: 0,
                            isSummary: "",
                            detailData: _ctx.summaryDetailData,
                            dexAssessmentData: _ctx.data.dexAssessment
                          }, null, 8, ["detailData", "dexAssessmentData"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_PartnerSection, {
                        isSummary: "",
                        data: _ctx.partnerData
                      }, null, 8, ["data"])
                    ], 2)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.activeTab === 'detail')
                ? (_openBlock(), _createBlock("div", _hoisted_4, [
                    _createVNode("div", {
                      class: `space-y-4 ${_ctx.isShowSolveTicketButton ? 'mb-16' : 'mb-10'}`
                    }, [
                      _withDirectives(_createVNode(_component_Note, {
                        modelValue: _ctx.data.ticket.note,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.data.ticket.note = $event)),
                        onSubmit: _ctx.onSubmitNote
                      }, null, 8, ["modelValue", "onSubmit"]), [
                        [_vShow, _ctx.isShowNote]
                      ]),
                      _createVNode(_component_SummarySTT, { detailData: _ctx.summaryDetailData }, null, 8, ["detailData"]),
                      _createVNode(_component_DetailItems, {
                        summary: _ctx.data.summary
                      }, null, 8, ["summary"]),
                      (_ctx.isDelDexCodrej)
                        ? (_openBlock(), _createBlock(_component_DelDexCodrej, {
                            key: 0,
                            detailData: _ctx.summaryDetailData,
                            dexAssessmentData: _ctx.data.dexAssessment
                          }, null, 8, ["detailData", "dexAssessmentData"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_PartnerSection, { data: _ctx.partnerData }, null, 8, ["data"])
                    ], 2)
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode(_component_Skeleton, { width: "90%" }),
                _createVNode(_component_Skeleton, { width: "70%" }),
                _createVNode(_component_Skeleton, { width: "100%" }),
                _createVNode(_component_Skeleton, { width: "50%" })
              ]),
              _createVNode("div", _hoisted_7, [
                _createVNode(_component_Skeleton, { width: "90%" }),
                _createVNode(_component_Skeleton, { width: "70%" }),
                _createVNode(_component_Skeleton, { width: "100%" }),
                _createVNode(_component_Skeleton, { width: "50%" })
              ]),
              _createVNode("div", _hoisted_8, [
                _createVNode(_component_Skeleton, { width: "90%" }),
                _createVNode(_component_Skeleton, { width: "70%" }),
                _createVNode(_component_Skeleton, { width: "100%" }),
                _createVNode(_component_Skeleton, { width: "50%" })
              ]),
              _createVNode("div", _hoisted_9, [
                _createVNode(_component_Skeleton, { width: "90%" }),
                _createVNode(_component_Skeleton, { width: "70%" }),
                _createVNode(_component_Skeleton, { width: "100%" }),
                _createVNode(_component_Skeleton, { width: "50%" })
              ]),
              _createVNode("div", _hoisted_10, [
                _createVNode(_component_Skeleton, { width: "90%" }),
                _createVNode(_component_Skeleton, { width: "70%" }),
                _createVNode(_component_Skeleton, { width: "100%" }),
                _createVNode(_component_Skeleton, { width: "50%" })
              ]),
              _createVNode("div", _hoisted_11, [
                _createVNode(_component_Skeleton, { width: "90%" }),
                _createVNode(_component_Skeleton, { width: "70%" }),
                _createVNode(_component_Skeleton, { width: "100%" }),
                _createVNode(_component_Skeleton, { width: "50%" })
              ]),
              _createVNode("div", _hoisted_12, [
                _createVNode(_component_Skeleton, { width: "90%" }),
                _createVNode(_component_Skeleton, { width: "70%" }),
                _createVNode(_component_Skeleton, { width: "100%" }),
                _createVNode(_component_Skeleton, { width: "50%" })
              ]),
              _createVNode("div", _hoisted_13, [
                _createVNode(_component_Skeleton, { width: "90%" }),
                _createVNode(_component_Skeleton, { width: "70%" }),
                _createVNode(_component_Skeleton, { width: "100%" }),
                _createVNode(_component_Skeleton, { width: "50%" })
              ]),
              _createVNode("div", _hoisted_14, [
                _createVNode(_component_Skeleton, { width: "90%" }),
                _createVNode(_component_Skeleton, { width: "70%" }),
                _createVNode(_component_Skeleton, { width: "100%" }),
                _createVNode(_component_Skeleton, { width: "50%" })
              ]),
              _createVNode("div", _hoisted_15, [
                _createVNode(_component_Skeleton, { width: "90%" }),
                _createVNode(_component_Skeleton, { width: "70%" }),
                _createVNode(_component_Skeleton, { width: "100%" }),
                _createVNode(_component_Skeleton, { width: "50%" })
              ]),
              _createVNode("div", _hoisted_16, [
                _createVNode(_component_Skeleton, { width: "90%" }),
                _createVNode(_component_Skeleton, { width: "70%" }),
                _createVNode(_component_Skeleton, { width: "100%" }),
                _createVNode(_component_Skeleton, { width: "50%" })
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", null, [
          (
            _ctx.errorState === _ctx.CLIENT_ERROR || _ctx.errorState === _ctx.INTERNAL_SERVER_ERROR
          )
            ? (_openBlock(), _createBlock(_component_EmptyState, {
                key: 0,
                customClass: "error-class",
                customHeaderMessage: _ctx.$t('Terjadi gangguan sistem'),
                customMessage: _ctx.$t('Klik Muat ulang atau coba beberapa saat lagi.'),
                icon: "error-token-ngen",
                buttonAction: {
            title: _ctx.$t('Muat ulang'),
            textColor: 'white',
            fontWeight: 'semibold',
            iconLeft: 'reload-white',
            sizeIcon: '12px'
          },
                onAction: _cache[5] || (_cache[5] = () => _ctx.$emit('getDetail'))
              }, null, 8, ["customHeaderMessage", "customMessage", "buttonAction"]))
            : _createCommentVNode("", true),
          (_ctx.errorState === _ctx.INTERNET_ERROR)
            ? (_openBlock(), _createBlock(_component_EmptyState, {
                key: 1,
                icon: "error-internet",
                customClass: "error-class",
                customHeaderMessage: _ctx.$t('Jaringan internet terputus'),
                customMessage: _ctx.$t('Periksa jaringan internal Anda lalu klik Muat ulang.'),
                buttonAction: {
            title: _ctx.$t('Muat ulang'),
            textColor: 'white',
            fontWeight: 'semibold',
            iconLeft: 'reload-white',
            sizeIcon: '12px'
          },
                onAction: _cache[6] || (_cache[6] = () => _ctx.$emit('getDetail'))
              }, null, 8, ["customHeaderMessage", "customMessage", "buttonAction"]))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.isShowSolveTicketButton)
        ? (_openBlock(), _createBlock("div", _hoisted_17, [
            _createVNode(_component_LpButton, {
              title: _ctx.$t('pusatResolusi.solveProblem'),
              onClick: _ctx.onShowModalFinish,
              "custom-class": "w-full",
              color: "red-lp-100",
              textColor: "white"
            }, null, 8, ["title", "onClick"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.reopenTicket)
        ? (_openBlock(), _createBlock("div", _hoisted_18, [
            _createVNode(_component_LpButton, {
              title: _ctx.$t('pusatResolusi.reopen.reopenTicket'),
              onClick: _ctx.onModalReopenReason,
              "custom-class": "w-full",
              color: "red-lp-100",
              textColor: "white"
            }, null, 8, ["title", "onClick"])
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(_component_ModalFinishIssue, {
      modelValue: _ctx.modalFinish,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.modalFinish = $event)),
      onSubmit: _ctx.onSubmitFinish
    }, null, 8, ["modelValue", "onSubmit"]),
    _createVNode(_component_ModalSuccessFinish, {
      modelValue: _ctx.modalSuccessFinish,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.modalSuccessFinish = $event)),
      noIssue: _ctx.issueNumber
    }, null, 8, ["modelValue", "noIssue"]),
    _createVNode(_component_ModalReopenReason, {
      modelValue: _ctx.isModalReopenReason,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.isModalReopenReason = $event)),
      onSubmit: _ctx.onSubmitReopen
    }, null, 8, ["modelValue", "onSubmit"]),
    _createVNode(_component_Snackbar, {
      "model-value": _ctx.isReopenSuccess,
      "onUpdate:modelValue": _ctx.toggleSnackbar,
      message: _ctx.reopenSuccessMessage,
      isPositive: true,
      snackbarBackgroundColor: "#E3FCEF",
      iconLeft: "check-circle",
      textColor: "text-green-lp-400 text-14px",
      isIconClose: false,
      timeout: 0,
      customWidth: "500px"
    }, null, 8, ["model-value", "onUpdate:modelValue", "message"])
  ], 64))
}